import { useEffect, useRef, useState } from "react";

export const img = (k) => `/img/${k}.webp`;

export function Img({ k, alt = "", className = "", style }) {
  return <img src={img(k)} alt={alt} decoding="async" draggable={false} className={`block w-full h-full object-cover ${className}`} style={style} />;
}

export function useWidth() {
  const ref = useRef(null);
  const [w, setW] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(([e]) => setW(e.contentRect.width));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return [ref, w];
}

export function DemoAction({ label, onCta, className = "", style, noteClass = "" }) {
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <button type="button" data-noswipe onClick={() => setShown((s) => !s)} className={className} style={style}>
        {label}
      </button>
      {shown && (
        <div role="status" className={`mt-3 max-w-[340px] rounded-lg border border-black/10 bg-white p-3 text-left font-sans text-[13px] leading-snug text-[#1A1C1E] shadow-lg ${noteClass}`}>
          <strong className="block">Fiktive Designstudie</strong>
          Diese Funktion ist nur ein Gestaltungsbeispiel – es wird nichts gebucht oder gesendet.
          {onCta && (
            <button type="button" data-noswipe onClick={onCta} className="mt-2 block font-semibold text-[#8A6418] underline underline-offset-2">
              Diesen Stil für meine Demo anfragen
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export function Chip({ active, onClick, children, activeCls, idleCls, className = "" }) {
  return (
    <button type="button" data-noswipe aria-pressed={active} onClick={onClick} className={`shrink-0 transition-colors duration-200 ${active ? activeCls : idleCls} ${className}`}>
      {children}
    </button>
  );
}
